/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type VerificationResponseType = 0 | 1 | 2 | 3;

export const VerificationResponseType = {
    NUMBER_0: 0 as VerificationResponseType,
    NUMBER_1: 1 as VerificationResponseType,
    NUMBER_2: 2 as VerificationResponseType,
    NUMBER_3: 3 as VerificationResponseType
};
